import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Profile from "@/components/Profile";
import Stats from "@/components/Stats";
import Timeline from "@/components/Timeline";
import Videos from "@/components/Videos";
import Gallery from "@/components/Gallery";
import Market from "@/components/Market";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-[#07090E] font-sans text-slate-100 antialiased">
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Profile />
          <Stats />
          <Timeline />
          <Videos />
          <Gallery />
          <Market />
          <Contact />
        </main>
        <Footer />
        <Toaster position="bottom-center" theme="dark" />
      </div>
    </LanguageProvider>
  );
}

export default App;
